import { render, staticRenderFns } from "./directives-config-card.component.vue?vue&type=template&id=6c4b55ca&scoped=true&"
import script from "./directives-config-card.component.vue?vue&type=script&lang=ts&"
export * from "./directives-config-card.component.vue?vue&type=script&lang=ts&"
import style0 from "./directives-config-card.component.vue?vue&type=style&index=0&id=6c4b55ca&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4b55ca",
  null
  
)

export default component.exports